import axios from "axios";
import { urlAPI } from "../../config/config";
import { showSnackbar } from "../../redux/actions";
import { IPayrollShuttleEntry } from "../../interface/payrollShuttle";

export const savePayrollShuttle = async (
    year: number,
    month: number,
    entries: IPayrollShuttleEntry[],
    token: string,
    setEntries: (entries: IPayrollShuttleEntry[]) => void,
    dispatch: Function,
    setError: Function
) => {
    try {
        const response = await axios.post(
            `${urlAPI}/payroll-shuttle/${year}/${month}/save`,
            { entries },
            { headers: { Authorization: `Bearer ${token}` } }
        );
        setEntries(response.data.message);
        dispatch(showSnackbar("Navette de paie enregistrée avec succès.", "success"));
    } catch (error: any) {
        console.error(error);
        setError("Impossible d'enregistrer la navette de paie.");
        dispatch(showSnackbar("Erreur lors de l'enregistrement de la navette de paie.", "error"));
    }
};
